import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// Services
import { type NewsType } from '@/services/news/newsService';

// Components
import Heading from '@/components/atoms/Heading/Heading';
import PreTitle from '@/components/atoms/PreTitle/PreTitle';

// Utils
import cn from '@/utils/cn';
import formatDate from '@/utils/formatDate';

// Other
import ArrowRightRed from '@/assets/icons/arrow-right-red.svg?react';

// Style
import styles from './BlocMiseEnAvant.module.css';

interface BlocMiseEnAvantProps {
  image: NewsType['image'];
  title: NewsType['title'];
  description?: NewsType['description'];
  url: NewsType['url'];
  publicationDate: NewsType['publicationDate'];
  imagePosition: NewsType['imagePosition'];
}

function BlocMiseEnAvant({
  image,
  title,
  description = null,
  url,
  publicationDate,
  imagePosition,
}: BlocMiseEnAvantProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.card}>
      <img
        src={image.url}
        alt={image.alternativeText || ''} height={200}
        className={cn([
          styles['card-image'],
          styles[`card-image-${imagePosition}`]
        ])}  
      />
      <div className={styles['card-content']}>
        <Heading 
          title={title}
          size='h4'
          Tag='h4'
          color='dark'
        />
        {
          description ? (
            <p className={styles['card-description']}>
              {description}
            </p>
          ) : (
            <p className={styles['card-description']} />
          )
        }
        <div className={styles['dotted-line']} />
        <div className={styles['card-footer']}>
          <PreTitle
            preTitle={formatDate(publicationDate)}
          />
          <Link to={url} className={styles['card-link']} target='_blank' rel="noreferrer">
            {
              t('section-actualite.read-article')
            }
            <ArrowRightRed />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BlocMiseEnAvant;
